import CreditBox from "./individual-services/CreditBox";
import ServiceActivationBox from "./individual-services/ServiceActivationBox";
import styles from "../../styles/Components/pricing-plan/IndividualServices.module.css";
import useUserTier from "../../hooks/useUserTier";
import RegionalDiscountButton from "./regional-discount/RegionalDiscountButton";
import { FaLocationDot } from "react-icons/fa6";
import { AiOutlineInfoCircle } from "react-icons/ai";
import usePageTitle from "../../hooks/usePageTitle";

function IndividualServices() {
  const { isVerified } = useUserTier();
  usePageTitle("Individual Services");

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleWrapper}>
          <h4 className={styles.title}>Custom Service</h4>
          {!isVerified && (
            <RegionalDiscountButton
              className={styles.discountBtn}
              icon={<FaLocationDot />}
            />
          )}
        </div>
        {!isVerified && (
          <div className={styles.offerGuide}>
            <p>
              <AiOutlineInfoCircle size={16} style={{ marginRight: ".2rem" }} />
              If you're located in a lower-income country or eligible region,
              you may qualify for a significant discount.
              <br /> Click the "Regional Offer" button above to verify your
              location and unlock your discount.
            </p>
          </div>
        )}
      </div>
      <div className={styles.header}>
        <CreditBox />
        {/*<EarnedMoneyBox />*/}
      </div>
      <ServiceActivationBox />
    </div>
  );
}

export default IndividualServices;
